import {Component, OnInit} from '@angular/core';
import {RuleService} from 'src/app/services/rule.service';
import {AccountService} from 'src/app/services/account.service';
import {CategoryService} from 'src/app/services/category.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {NotificationService} from '../../../../services/notification.service';
import {RuleDTO} from '../../../../model/ruleDTO';


@Component({
  selector: 'app-add-rule',
  templateUrl: './add-rule.component.html',
})
export class AddRuleComponent implements OnInit {

  categories = [{key: 'CREDIT', label: 'Inkomsten'}, {key: 'DEBIT', label: 'Uitgaven'}, {key: 'CREDIT_AND_DEBIT', label: 'Inkomsten & uitgaven'}];
  subcategories;
  description: string;
  category: any;
  subCategoryId: number;
  ibanRequiredEmpty: boolean;
  iban: string;

  constructor(private service: RuleService,
              private accountService: AccountService,
              private categoryService: CategoryService,
              private notificationService: NotificationService,
              private router: Router,
              public translate: TranslateService) {
    translate.use('nl');
  }

  ngOnInit(): void {
    this.categoryService.getSubcategories().subscribe(response => {
      this.subcategories = response;
    });
  }

  save() {
    if (!(this.category != null && this.subCategoryId != null &&
      (!this.isNullOrBlank(this.iban) || !this.isNullOrBlank(this.description)))) {
      this.notificationService.warning('Kies een post in combinatie met een omschrijving en/of IBAN.');
      return null;
    }

    if (!this.isNullOrBlank(this.iban)) {
      this.notificationService.warning('geen geldig IBAN');
      return null;
    }

    const newRule: RuleDTO = {
      subCategoryId: this.subCategoryId,
      description: this.description,
      iban: this.iban,
      ibanRequiredEmpty: this.ibanRequiredEmpty
    };
    this.service.save(newRule).subscribe(() => {
      this.notificationService.success('regel toegevoegd');
      this.router.navigate(['/regels']);
    }, error => {
      this.notificationService.errorResponse(error);
    });
  }

  getSubcategories() {
    const filter = subcategory => subcategory.type === this.category;
    return this.subcategories.filter(filter);
  }

  isNullOrBlank(str) {
    return str == null || str === '';
  }

  ibanChange() {
    if (this.isNullOrBlank(this.iban)) {
      this.ibanRequiredEmpty = false;
    }
  }

  ibanRequiredEmptyChange() {
    if (this.ibanRequiredEmpty) {
      this.iban = '';
    }
  }
}
